module.exports = __webpack_public_path__ + "static/media/fotoperfil.74a6ccf8.jpg";